export type Lang = 'en' | 'ar';

export const TRANSLATIONS: Record<Lang, Record<string, string>> = {
  en: {
    // ── Header / Nav ──────────────────────────────────────────────────────────
    'nav.home': 'Home',
    'nav.about': 'About',
    'nav.categories': 'Categories',
    'nav.packages': 'Packages',
    'nav.shop': 'Shop',
    'nav.blogs': 'Blogs',
    'nav.request': 'Request Product',
    'nav.login': 'Login',
    'nav.register': 'Register',
    'nav.profile': 'Profile',
    'nav.logout': 'Logout',
    'nav.journal': 'Journal',
    'nav.signin': 'Sign In',

    // ── Hero Banner ───────────────────────────────────────────────────────────
    'hero.title1': 'Authentic beauty',
    'hero.title2': 'beyond borders',
    'hero.cta.shop': 'Shop Now',
    'hero.cta.explore': 'Explore',
    'hero.trust.brands_num': '200+',
    'hero.trust.brands_label': 'Brands',
    'hero.trust.auth_num': '100%',
    'hero.trust.auth_label': 'Authentic',
    'hero.trust.delivery_label': 'Delivery',
    'hero.trust.fast': 'Fast',

    // ── Categories ────────────────────────────────────────────────────────────
    'cats.eyebrow': 'Collections',
    'cats.title1': 'All',
    'cats.title2': 'Categories',
    'cats.sub': 'Discover your next ritual',
    'cats.shop': 'Shop Now',
    'cats.hero_discover': 'Discover',
    'cats.hero_title1': 'All',
    'cats.hero_title2': 'Collections',
    'cats.hero_sub': 'Every ritual. Every product. Curated for you.',
    'cats.scroll': 'Scroll',
    'cats.collections_label': 'Collections',
    'cats.explore': 'Explore',

    // ── Why Us ────────────────────────────────────────────────────────────────
    'why.chat.title': "We're Here For You",
    'why.chat.body': 'Reach us anytime via our Facebook chat — real humans, real help.',
    'why.request.title': "Can't Find Your Product?",
    'why.request.body': 'Request any item with an image or URL — we\'ll source it for you.',
    'why.brands.title': '200+ Authentic Brands',
    'why.brands.body': 'Every product sourced from official distributors — guaranteed genuine.',

    // ── Brands ────────────────────────────────────────────────────────────────
    'brands.title': 'Our Brands',

    // ── Editorial ─────────────────────────────────────────────────────────────
    'edit.title1': "This season's",
    'edit.title2': 'most-loved picks',
    'edit.sub': 'A thoughtful curation of skincare and wellness products our clients love most.',
    'edit.cta': 'Shop the Collection',

    // ── Product of the Week ───────────────────────────────────────────────────
    'potw.eyebrow': 'Product of the Week',
    'potw.cta': 'Shop Now',

    // ── Best Sellers ──────────────────────────────────────────────────────────
    'bs.title1': 'Our',
    'bs.title2': 'Best Sellers',
    'bs.sub': 'Products our clients return to again and again',
    'bs.rank': 'Best Seller',
    'bs.cta': 'View Product',
    'bs.view_all': 'View All Products',

    // ── Mood Banner ───────────────────────────────────────────────────────────
    'mood.quote': '"A daily ritual for skin, mind, and self."',
    'mood.cta': 'Explore the Collection',

    // ── Packages ──────────────────────────────────────────────────────────────
    'packs.title': 'Trending Packages',
    'packs.label': 'Curated For You',
    'packs.header': 'Our Packages',
    'packs.coming': 'Stay tuned for our coming packages',

    // ── Footer ────────────────────────────────────────────────────────────────
    'footer.nav': 'Navigate',
    'footer.account': 'Account',
    'footer.contact': 'Contact',
    'footer.follow': 'Follow Us',
    'footer.orders': 'My Orders',
    'footer.cart': 'Cart',
    'footer.copyright': 'Copyright © 2024 Radwa Khallaf — All rights reserved',

    // ── About ─────────────────────────────────────────────────────────────────
    'about.eyebrow': 'Our Story',
    'about.title1': 'About',
    'about.title2': 'Us',
    'about.lead': 'What started as a small circle sharing honest opinions on everyday products has grown into a 100k+ community, a curated catalog of authentic brands, and now — a home of our own.',
    'about.body': 'Years of trust, thousands of loyal customers, and a commitment to only carrying products we genuinely believe in — that is what brought us here. This website is not just a shop; it is the next chapter. Browse, discover, and know that every single item was chosen with you in mind.',
    'about.stat1.label': 'Community Members',
    'about.stat2.label': 'Curated Brands',
    'about.stat3.label': 'Genuine Products',
    'about.founder': 'Founder & Creator',

    // ── Shop ──────────────────────────────────────────────────────────────────
    'shop.label': 'Browse',
    'shop.title': 'Our Collection',
    'shop.sub': 'Discover premium beauty & wellness products, curated with care.',
    'shop.view': 'View Details',

    // ── Login ─────────────────────────────────────────────────────────────────
    'login.welcome': 'Welcome back',
    'login.email_label': 'Email or Phone Number',
    'login.email_placeholder': 'you@example.com or 01XXXXXXXXX',
    'login.password_label': 'Password',
    'login.password_placeholder': '••••••••',
    'login.forgot': 'Forgot password?',
    'login.submit': 'Sign In',
    'login.no_account': "Don't have an account?",
    'login.create': 'Create one',
    'login.err.required_email': 'Email or phone number is required',
    'login.err.invalid_email': 'Please enter a valid email or phone number',
    'login.err.required_pw': 'Password is required',

    // ── Sign Up ───────────────────────────────────────────────────────────────
    'signup.title': 'Create Account',
    'signup.new_here': 'New here?',
    'signup.sub': 'Join Radwa Khallaf for an elevated shopping experience.',
    'signup.have_account': 'Already have an account?',
    'signup.signin': 'Sign In',
    'signup.submit': 'Create Account',
    'signup.username_label': 'Username',
    'signup.username_placeholder': 'your_username',
    'signup.username_hint': 'Username cannot include spaces',
    'signup.username_required': 'Username is required',
    'signup.email_label': 'Email Address',
    'signup.email_placeholder': 'you@example.com',
    'signup.email_required': 'Email is required',
    'signup.email_invalid': 'Please enter a valid email address',
    'signup.phone_label': 'Phone Number',
    'signup.phone_placeholder': '01XXXXXXXXX',
    'signup.phone_required': 'Phone number is required',
    'signup.phone_invalid': 'Please enter a valid Egyptian phone number',
    'signup.password_label': 'Password',
    'signup.password_placeholder': 'At least 8 characters',
    'signup.password_hint': 'Must be at least 8 characters',
    'signup.password_required': 'Password is required',

    // ── Product Details ───────────────────────────────────────────────────────
    'prod.add_cart': 'Add to Cart',
    'prod.out_of_stock': 'Out of Stock',
    'prod.reviews': 'Reviews',
    'prod.no_reviews': 'No reviews yet. Be the first.',
    'prod.write_review': 'Write a Review',
    'prod.submit_review': 'Submit Review',
    'prod.variants': 'Options',
    'prod.delivery_note': 'Order will arrive in 14 business days',
    'prod.wishlist_add': 'Add to Wishlist',
    'prod.wishlist_remove': 'Remove from Wishlist',
    'prod.collection': 'Premium Collection',
    'prod.desc_title': 'Product Description',
    'prod.screenshots': 'Screenshots',
    'prod.videos': 'Videos',
    'prod.review_leave': 'Leave a Review',
    'prod.review_rating': 'Your rating',
    'prod.review_label': 'Your review',
    'prod.review_placeholder': 'Share your experience…',

    // ── Cart ──────────────────────────────────────────────────────────────────
    'cart.title': 'Your Cart',
    'cart.empty': 'Your cart is empty.',
    'cart.checkout': 'Checkout',
    'cart.total': 'Total',
    'cart.remove': 'Remove',
    'cart.discover': 'Discover Products',
    'cart.remove_all': 'Remove all',
    'cart.notice': 'Order will arrive between 15–20 business days',
    'cart.package_label': 'Package',
    'cart.summary': 'Order Summary',
    'cart.delivery_region': 'Delivery Region',
    'cart.select_region': 'Select your region',
    'cart.region.cairo': 'Cairo',
    'cart.region.alex': 'Alexandria',
    'cart.region.delta': 'Delta',
    'cart.region.canal': 'Canal',
    'cart.region.north': 'North Coast & Upper Egypt',
    'cart.region.sinai': 'Sinai & Red Sea',
    'cart.contact_phone': 'Contact Phone',
    'cart.delivery_address': 'Delivery Address',
    'cart.add_address': 'Add Your Address',
    'cart.add_new': '+ Add New Address',
    'cart.save_address': 'Save Address',
    'cart.back': 'Back',
    'cart.city': 'City',
    'cart.governorate': 'Governorate',
    'cart.street': 'Street Address',
    'cart.street_placeholder': 'Street, building, floor…',
    'cart.promo': 'Promo Code',
    'cart.promo_placeholder': 'Enter promo code',
    'cart.promo_apply': 'Apply',
    'cart.promo_saved': 'Promo applied — you saved',
    'cart.promo_invalid': 'Promo code not valid',
    'cart.payment': 'Payment Method',
    'cart.cod': 'Cash on Delivery',
    'cart.vodafone': 'Vodafone Cash',
    'cart.subtotal': 'Subtotal',
    'cart.delivery_fees': 'Delivery Fees',
    'cart.select_above': 'Select region above',
    'cart.confirm': 'Confirm Order',
    'cart.phone_required': 'Phone number is required',
    'cart.phone_invalid': 'Please enter a valid phone number',
    'cart.missing_region': 'Select a delivery region',
    'cart.missing_phone': 'Enter a valid phone number',
    'cart.missing_address': 'Choose a delivery address',
    'cart.missing_payment': 'Choose a payment method',

    // ── Wishlist ──────────────────────────────────────────────────────────────
    'wishlist.title': 'My Wishlist',
    'wishlist.empty': 'Your wishlist is empty.',

    // ── Blogs ─────────────────────────────────────────────────────────────────
    'blogs.label': 'Stories & Insights',
    'blogs.title': 'Our Journal',
    'blogs.read_more': 'Read More',

    // ── General ───────────────────────────────────────────────────────────────
    'general.loading': 'Loading...',
    'general.error': 'Something went wrong. Please try again.',

    // ── User Profile ──────────────────────────────────────────────────────────
    'profile.hello': 'Hello',
    'profile.edit_account': 'Edit my account',
    'profile.tab.personal': 'Personal Information',
    'profile.tab.orders': 'My Orders',
    'profile.tab.requests': 'Product Requests',
    'profile.personal_info': 'Personal Information',
    'profile.place': 'Place',
    'profile.mobile': 'Mobile Number',
    'profile.edit_personal': 'Edit Personal Info',
    'profile.login_info': 'Login Info',
    'profile.email': 'E-mail',
    'profile.username': 'User Name',
    'profile.more_info': 'More Information',
    'profile.best_surprise': 'Best surprise',
    'profile.fav_color': 'Favorite colour',
    'profile.marital_status': 'Marital status',
    'profile.goals': 'Ultimate goals',
    'profile.edit_more': 'Edit More Info',
    'profile.history': 'History Order',
    'profile.order_sent': 'Order Sent',
    'profile.order_number': 'Order Number',
    'profile.date_order': 'Date Order',
    'profile.payment': 'Payment',
    'profile.cod': 'Cash On Delivery',
    'profile.vodafone': 'Vodafone Cash',
    'profile.total': 'Total',
    'profile.paid': 'Paid',
    'profile.no': 'No',
    'profile.yes': 'Yes',
    'profile.expected': 'Expected arrival',
    'profile.total_items': 'Total Items',
    'profile.col.image': 'Image',
    'profile.col.product': 'Product name',
    'profile.col.qty': 'Quantity',
    'profile.col.price': 'Price',
    'profile.col.package': 'Package name',
    'profile.col.no_products': 'No of products',
    'profile.cancel_order': 'Cancel order',
    'profile.edit_order': 'Edit order',
    'profile.order_request': 'Order Request',
    'profile.name': 'Name',
    'profile.url': 'URL',
    'profile.no_product': 'No Product Found',
    'profile.status.cancelled': 'Cancelled',
    'profile.status.delivered': 'Delivered',
    'profile.status.processing': 'Processing',
    'profile.status.pending': 'Pending',

    // ── Blog Details ──────────────────────────────────────────────────────────
    'blog.posted_on': 'POSTED ON',
    'blog.products': 'Products',

    // ── Checkout ──────────────────────────────────────────────────────────────
    'checkout.title': 'Choose Payment',
    'checkout.confirm': 'Confirm',

    // ── Toast ─────────────────────────────────────────────────────────────────
    'toast.title_success': 'Done',
    'toast.title_error': 'Error',
    'toast.login_success': 'Logged in successfully',
    'toast.register_success': 'Account created successfully',
    'toast.password_changed': 'Password changed successfully',
    'toast.check_email': 'Check your email',
    'toast.order_received': 'Order received',
    'toast.address_added': 'Address added successfully',
    'toast.cart_added': 'Added to your cart',
    'toast.wishlist_added': 'Added to wishlist',
    'toast.wishlist_removed': 'Removed from wishlist',
    'toast.order_cancelled': 'Order cancelled',
    'toast.request_submitted': 'Your request is being processed — you will receive an email for confirmation',
    'toast.error_generic': 'Something went wrong, please try again',
    'toast.login_wrong_creds': 'Please check your email or password',
    'toast.email_not_found': 'Email not found',
  },

  ar: {
    // ── Header / Nav ──────────────────────────────────────────────────────────
    'nav.home': 'الرئيسية',
    'nav.about': 'من نحن',
    'nav.categories': 'الفئات',
    'nav.packages': 'الباقات',
    'nav.shop': 'المتجر',
    'nav.blogs': 'المدونة',
    'nav.request': 'طلب منتج',
    'nav.login': 'تسجيل الدخول',
    'nav.register': 'إنشاء حساب',
    'nav.profile': 'الملف الشخصي',
    'nav.logout': 'تسجيل الخروج',
    'nav.journal': 'المجلة',
    'nav.signin': 'تسجيل الدخول',

    // ── Hero Banner ───────────────────────────────────────────────────────────
    'hero.title1': 'جمال أصيل',
    'hero.title2': 'بلا حدود',
    'hero.cta.shop': 'تسوقي الآن',
    'hero.cta.explore': 'اكتشفي',
    'hero.trust.brands_num': '200+',
    'hero.trust.brands_label': 'علامة تجارية',
    'hero.trust.auth_num': '100%',
    'hero.trust.auth_label': 'أصيل',
    'hero.trust.delivery_label': 'توصيل',
    'hero.trust.fast': 'سريع',

    // ── Categories ────────────────────────────────────────────────────────────
    'cats.eyebrow': 'المجموعات',
    'cats.title1': 'جميع',
    'cats.title2': 'الفئات',
    'cats.sub': 'اكتشفي طقوسك القادمة',
    'cats.shop': 'تسوقي الآن',
    'cats.hero_discover': 'اكتشفي',
    'cats.hero_title1': 'جميع',
    'cats.hero_title2': 'المجموعات',
    'cats.hero_sub': 'كل طقس. كل منتج. مختار من أجلك.',
    'cats.scroll': 'اسحبي',
    'cats.collections_label': 'مجموعة',
    'cats.explore': 'استكشفي',

    // ── Why Us ────────────────────────────────────────────────────────────────
    'why.chat.title': 'نحن هنا من أجلك',
    'why.chat.body': 'تواصلي معنا في أي وقت عبر فيسبوك — بشر حقيقيون، مساعدة حقيقية.',
    'why.request.title': 'لا تجدين ما تبحثين عنه؟',
    'why.request.body': 'اطلبي أي منتج بصورة أو رابط وسنجلبه لك.',
    'why.brands.title': 'أكثر من 200 علامة تجارية أصيلة',
    'why.brands.body': 'كل منتج من موزعين رسميين — أصالة مضمونة.',

    // ── Brands ────────────────────────────────────────────────────────────────
    'brands.title': 'علاماتنا التجارية',

    // ── Editorial ─────────────────────────────────────────────────────────────
    'edit.title1': 'أكثر ما أُحب',
    'edit.title2': 'هذا الموسم',
    'edit.sub': 'تشكيلة مختارة من منتجات العناية بالبشرة والعافية التي تعشقها عميلاتنا.',
    'edit.cta': 'تسوقي المجموعة',

    // ── Product of the Week ───────────────────────────────────────────────────
    'potw.eyebrow': 'منتج الأسبوع',
    'potw.cta': 'تسوقي الآن',

    // ── Best Sellers ──────────────────────────────────────────────────────────
    'bs.title1': 'أكثر',
    'bs.title2': 'منتجاتنا مبيعاً',
    'bs.sub': 'منتجات تعود إليها عميلاتنا مراراً وتكراراً',
    'bs.rank': 'الأكثر مبيعاً',
    'bs.cta': 'عرض المنتج',
    'bs.view_all': 'عرض جميع المنتجات',

    // ── Mood Banner ───────────────────────────────────────────────────────────
    'mood.quote': '"طقس يومي للبشرة والعقل والروح."',
    'mood.cta': 'اكتشفي المجموعة',

    // ── Packages ──────────────────────────────────────────────────────────────
    'packs.title': 'الباقات الرائجة',
    'packs.label': 'مختارة لك',
    'packs.header': 'باقاتنا',
    'packs.coming': 'ترقبي باقاتنا القادمة',

    // ── Footer ────────────────────────────────────────────────────────────────
    'footer.nav': 'التنقل',
    'footer.account': 'الحساب',
    'footer.contact': 'اتصل بنا',
    'footer.follow': 'تابعينا',
    'footer.orders': 'طلباتي',
    'footer.cart': 'سلة التسوق',
    'footer.copyright': 'حقوق النشر © 2024 رضوى خلاف — جميع الحقوق محفوظة',

    // ── About ─────────────────────────────────────────────────────────────────
    'about.eyebrow': 'قصتنا',
    'about.title1': 'من',
    'about.title2': 'نحن',
    'about.lead': 'ما بدأ كدائرة صغيرة تتبادل آراء صادقة حول منتجات يومية، نما ليصبح مجتمعاً يضم أكثر من 100 ألف عضو، وكتالوجاً مختاراً من العلامات التجارية الأصيلة — والآن، بيتنا الخاص.',
    'about.body': 'سنوات من الثقة، وآلاف العملاء الأوفياء، والتزام بحمل المنتجات التي نؤمن بها حقاً — هذا ما جاء بنا إلى هنا. هذا الموقع ليس متجراً فحسب؛ إنه الفصل التالي. تصفحي، اكتشفي، واعلمي أن كل منتج اخترناه مع وضعك في الاعتبار.',
    'about.stat1.label': 'عضو في المجتمع',
    'about.stat2.label': 'علامة تجارية مختارة',
    'about.stat3.label': 'منتج أصيل',
    'about.founder': 'المؤسسة والمبدعة',

    // ── Shop ──────────────────────────────────────────────────────────────────
    'shop.label': 'تصفح',
    'shop.title': 'مجموعتنا',
    'shop.sub': 'اكتشفي منتجات الجمال والعافية المميزة، المختارة بعناية.',
    'shop.view': 'عرض التفاصيل',

    // ── Login ─────────────────────────────────────────────────────────────────
    'login.welcome': 'أهلاً بعودتك',
    'login.email_label': 'البريد الإلكتروني أو رقم الهاتف',
    'login.email_placeholder': 'you@example.com أو 01XXXXXXXXX',
    'login.password_label': 'كلمة المرور',
    'login.password_placeholder': '••••••••',
    'login.forgot': 'نسيت كلمة المرور؟',
    'login.submit': 'تسجيل الدخول',
    'login.no_account': 'ليس لديك حساب؟',
    'login.create': 'إنشاء حساب',
    'login.err.required_email': 'البريد الإلكتروني أو رقم الهاتف مطلوب',
    'login.err.invalid_email': 'يرجى إدخال بريد إلكتروني أو رقم هاتف صحيح',
    'login.err.required_pw': 'كلمة المرور مطلوبة',

    // ── Sign Up ───────────────────────────────────────────────────────────────
    'signup.title': 'إنشاء حساب',
    'signup.new_here': 'هنا لأول مرة؟',
    'signup.sub': 'انضمي إلى رضوى خلاف لتجربة تسوق راقية.',
    'signup.have_account': 'لديك حساب بالفعل؟',
    'signup.signin': 'تسجيل الدخول',
    'signup.submit': 'إنشاء حساب',
    'signup.username_label': 'اسم المستخدم',
    'signup.username_placeholder': 'your_username',
    'signup.username_hint': 'لا يمكن أن يحتوي اسم المستخدم على مسافات',
    'signup.username_required': 'اسم المستخدم مطلوب',
    'signup.email_label': 'البريد الإلكتروني',
    'signup.email_placeholder': 'you@example.com',
    'signup.email_required': 'البريد الإلكتروني مطلوب',
    'signup.email_invalid': 'يرجى إدخال بريد إلكتروني صحيح',
    'signup.phone_label': 'رقم الهاتف',
    'signup.phone_placeholder': '01XXXXXXXXX',
    'signup.phone_required': 'رقم الهاتف مطلوب',
    'signup.phone_invalid': 'يرجى إدخال رقم هاتف مصري صحيح',
    'signup.password_label': 'كلمة المرور',
    'signup.password_placeholder': '8 أحرف على الأقل',
    'signup.password_hint': 'يجب أن تكون 8 أحرف على الأقل',
    'signup.password_required': 'كلمة المرور مطلوبة',

    // ── Product Details ───────────────────────────────────────────────────────
    'prod.add_cart': 'أضيفي للسلة',
    'prod.out_of_stock': 'نفذ المخزون',
    'prod.reviews': 'التقييمات',
    'prod.no_reviews': 'لا توجد تقييمات بعد. كوني الأولى.',
    'prod.write_review': 'اكتبي تقييماً',
    'prod.submit_review': 'إرسال التقييم',
    'prod.variants': 'الخيارات',
    'prod.delivery_note': 'سيصل الطلب خلال 14 يوم عمل',
    'prod.wishlist_add': 'أضيفي للمفضلة',
    'prod.wishlist_remove': 'إزالة من المفضلة',
    'prod.collection': 'مجموعة مميزة',
    'prod.desc_title': 'وصف المنتج',
    'prod.screenshots': 'صور إضافية',
    'prod.videos': 'فيديوهات',
    'prod.review_leave': 'اتركي تقييماً',
    'prod.review_rating': 'تقييمك',
    'prod.review_label': 'تقييمك',
    'prod.review_placeholder': 'شاركي تجربتك…',

    // ── Cart ──────────────────────────────────────────────────────────────────
    'cart.title': 'سلتك',
    'cart.empty': 'سلتك فارغة.',
    'cart.checkout': 'إتمام الشراء',
    'cart.total': 'الإجمالي',
    'cart.remove': 'إزالة',
    'cart.discover': 'اكتشفي المنتجات',
    'cart.remove_all': 'إزالة الكل',
    'cart.notice': 'سيصل الطلب خلال 15–20 يوم عمل',
    'cart.package_label': 'باقة',
    'cart.summary': 'ملخص الطلب',
    'cart.delivery_region': 'منطقة التوصيل',
    'cart.select_region': 'اختاري منطقتك',
    'cart.region.cairo': 'القاهرة',
    'cart.region.alex': 'الإسكندرية',
    'cart.region.delta': 'الدلتا',
    'cart.region.canal': 'القناة',
    'cart.region.north': 'الساحل الشمالي وصعيد مصر',
    'cart.region.sinai': 'سيناء والبحر الأحمر',
    'cart.contact_phone': 'هاتف التواصل',
    'cart.delivery_address': 'عنوان التوصيل',
    'cart.add_address': 'أضيفي عنوانك',
    'cart.add_new': '+ إضافة عنوان جديد',
    'cart.save_address': 'حفظ العنوان',
    'cart.back': 'رجوع',
    'cart.city': 'المدينة',
    'cart.governorate': 'المحافظة',
    'cart.street': 'عنوان الشارع',
    'cart.street_placeholder': 'الشارع، المبنى، الطابق…',
    'cart.promo': 'كود الخصم',
    'cart.promo_placeholder': 'أدخلي كود الخصم',
    'cart.promo_apply': 'تطبيق',
    'cart.promo_saved': 'تم تطبيق الخصم — وفّرتِ',
    'cart.promo_invalid': 'كود الخصم غير صحيح',
    'cart.payment': 'طريقة الدفع',
    'cart.cod': 'الدفع عند الاستلام',
    'cart.vodafone': 'فودافون كاش',
    'cart.subtotal': 'المجموع الجزئي',
    'cart.delivery_fees': 'رسوم التوصيل',
    'cart.select_above': 'اختاري المنطقة أعلاه',
    'cart.confirm': 'تأكيد الطلب',
    'cart.phone_required': 'رقم الهاتف مطلوب',
    'cart.phone_invalid': 'يرجى إدخال رقم هاتف صحيح',
    'cart.missing_region': 'اختاري منطقة التوصيل',
    'cart.missing_phone': 'أدخلي رقم هاتف صحيح',
    'cart.missing_address': 'اختاري عنوان التوصيل',
    'cart.missing_payment': 'اختاري طريقة الدفع',

    // ── Wishlist ──────────────────────────────────────────────────────────────
    'wishlist.title': 'قائمة المفضلة',
    'wishlist.empty': 'قائمة مفضلتك فارغة.',

    // ── Blogs ─────────────────────────────────────────────────────────────────
    'blogs.label': 'قصص وأفكار',
    'blogs.title': 'مجلتنا',
    'blogs.read_more': 'اقرأي المزيد',

    // ── General ───────────────────────────────────────────────────────────────
    'general.loading': 'جار التحميل...',
    'general.error': 'حدث خطأ ما. يرجى المحاولة مرة أخرى.',

    // ── User Profile ──────────────────────────────────────────────────────────
    'profile.hello': 'مرحباً',
    'profile.edit_account': 'تعديل حسابي',
    'profile.tab.personal': 'المعلومات الشخصية',
    'profile.tab.orders': 'طلباتي',
    'profile.tab.requests': 'طلبات المنتجات',
    'profile.personal_info': 'المعلومات الشخصية',
    'profile.place': 'المدينة',
    'profile.mobile': 'رقم الهاتف',
    'profile.edit_personal': 'تعديل المعلومات الشخصية',
    'profile.login_info': 'معلومات تسجيل الدخول',
    'profile.email': 'البريد الإلكتروني',
    'profile.username': 'اسم المستخدم',
    'profile.more_info': 'معلومات إضافية',
    'profile.best_surprise': 'أفضل مفاجأة',
    'profile.fav_color': 'اللون المفضل',
    'profile.marital_status': 'الحالة الاجتماعية',
    'profile.goals': 'الأهداف الكبرى',
    'profile.edit_more': 'تعديل المعلومات الإضافية',
    'profile.history': 'سجل الطلبات',
    'profile.order_sent': 'تم إرسال الطلب',
    'profile.order_number': 'رقم الطلب',
    'profile.date_order': 'تاريخ الطلب',
    'profile.payment': 'طريقة الدفع',
    'profile.cod': 'الدفع عند الاستلام',
    'profile.vodafone': 'فودافون كاش',
    'profile.total': 'الإجمالي',
    'profile.paid': 'مدفوع',
    'profile.no': 'لا',
    'profile.yes': 'نعم',
    'profile.expected': 'الوصول المتوقع',
    'profile.total_items': 'عدد المنتجات',
    'profile.col.image': 'الصورة',
    'profile.col.product': 'اسم المنتج',
    'profile.col.qty': 'الكمية',
    'profile.col.price': 'السعر',
    'profile.col.package': 'اسم الباقة',
    'profile.col.no_products': 'عدد المنتجات',
    'profile.cancel_order': 'إلغاء الطلب',
    'profile.edit_order': 'تعديل الطلب',
    'profile.order_request': 'طلب منتج',
    'profile.name': 'الاسم',
    'profile.url': 'الرابط',
    'profile.no_product': 'لا توجد منتجات',
    'profile.status.cancelled': 'ملغي',
    'profile.status.delivered': 'تم التسليم',
    'profile.status.processing': 'قيد المعالجة',
    'profile.status.pending': 'قيد الانتظار',

    // ── Blog Details ──────────────────────────────────────────────────────────
    'blog.posted_on': 'نُشر في',
    'blog.products': 'المنتجات',

    // ── Checkout ──────────────────────────────────────────────────────────────
    'checkout.title': 'اختاري طريقة الدفع',
    'checkout.confirm': 'تأكيد',

    // ── Toast ─────────────────────────────────────────────────────────────────
    'toast.title_success': 'تم',
    'toast.title_error': 'خطأ',
    'toast.login_success': 'تم تسجيل الدخول بنجاح',
    'toast.register_success': 'تم إنشاء الحساب بنجاح',
    'toast.password_changed': 'تم تغيير كلمة المرور بنجاح',
    'toast.check_email': 'تحققي من بريدك الإلكتروني',
    'toast.order_received': 'تم استلام الطلب',
    'toast.address_added': 'تمت إضافة العنوان بنجاح',
    'toast.cart_added': 'تمت الإضافة إلى سلتك',
    'toast.wishlist_added': 'تمت الإضافة إلى المفضلة',
    'toast.wishlist_removed': 'تمت الإزالة من المفضلة',
    'toast.order_cancelled': 'تم إلغاء الطلب',
    'toast.request_submitted': 'جارٍ معالجة طلبك — ستصلك رسالة بريد إلكتروني للتأكيد',
    'toast.error_generic': 'حدث خطأ ما، يرجى المحاولة مرة أخرى',
    'toast.login_wrong_creds': 'يرجى التحقق من البريد الإلكتروني أو كلمة المرور',
    'toast.email_not_found': 'البريد الإلكتروني غير موجود',
  },
};
